import React from 'react';
import {Trans} from 'react-i18next';
import {Entry, TimelineEntry} from './Shared';

export const CustomerAddedTimelineEntry = ({entry}) => {
    return (
        <TimelineEntry entry={entry} status="new" icon="person">
            <Entry.Title>
                <Trans i18nKey="warehousing.timeline.CustomerAdded.title" values={{name: entry.customerName}} />
            </Entry.Title>
        </TimelineEntry>
    );
};
